export const DEFAULT_AFFILIATE_ID = 'stayforlong'
